export default {
  initClientToken: async () => {
    return new Promise((resolve, reject) => {
      try {
        const { REACT_APP_GOOGLE_LEADS_API_CLIENT_ID } = process.env;

        let client = google.accounts.oauth2.initCodeClient({
          client_id: REACT_APP_GOOGLE_LEADS_API_CLIENT_ID,
          scope:
            "https://www.googleapis.com/auth/drive.file \
            https://www.googleapis.com/auth/userinfo.email \
            https://www.googleapis.com/auth/userinfo.profile",
          ux_mode: "popup",
          callback: (response) => {
            console.log("Google initClientToken response: ", response);

            resolve(response);
          },
        });
        client.requestCode();
      } catch (error) {
        console.log("Google initClientToken Error: ", error?.message);
        resolve(false);
      }
    });
  },
};
